import "./slider.css";
import { useEffect, useRef } from "react";
import playLeft from "../../picture/play-left.png";
import playRight from "../../picture/play-right.png";
import { format, compareAsc } from "date-fns";

const Slider = ({
  selectedDate,
  currentNotification,
  setCurrentNotification,
  isFromSliderRef,
  isEditing,
  setIsEditing,
}) => {
  let currentTime,
    correctDot,
    dotPosition,
    shift,
    previousPosition,
    isValidated;

  const startMarker = useRef();
  const endMarker = useRef();
  const startMoving = useRef();
  const termWidth = useRef();
  const fillCreated = useRef();
  const isFromAdmin = useRef();
  const dot = useRef();

  const handleStartMoving = (e) => {
    const arrows = document.querySelectorAll(".arrow");
    arrows.forEach((arrow) => arrow.remove());
    const sliderMarkers = document.querySelector(".slider-markers");
    startMoving.current =
      sliderMarkers.getBoundingClientRect().x +
      e.currentTarget.getBoundingClientRect().width / 2;
    isFromAdmin.current = true;
    e.currentTarget.addEventListener("mousemove", handleMoving);
    // setovanje pocetne pozicije (za validaciju)
    previousPosition =
      e.currentTarget.getBoundingClientRect().left +
      e.currentTarget.getBoundingClientRect().width -
      startMoving.current;
  };

  const handleCreateMarkers = () => {
    const spanFirst = document.querySelector(".span-start");
    const spanSecond = document.querySelector(".span-end");
    shift = {
      isStartMoved: startMarker.current !== undefined,
      isEndMoved: endMarker.current !== undefined,
      startTime: spanFirst.innerHTML,
      endTime: spanSecond.innerHTML,
    };
  };

  const updateTimeSpan = (movingElement, cond) => {
    let currentSpan;

    if (movingElement.classList.contains("start")) {
      currentSpan = document.querySelector(".span-start");
      if (currentNotification.startTime !== "" && cond)
        currentSpan.innerHTML = currentNotification.startTime;
      else currentSpan.innerHTML = currentTime;

      if (currentSpan === null) return;
      const sliderLine = document.querySelector(".slider-line");
      const sliderRight = sliderLine.getBoundingClientRect().right;
      const movingElementRight = movingElement.getBoundingClientRect().right;
      // ovaj uslov je za desno

      if (
        sliderRight >
        movingElementRight +
          2 *
            Math.abs(
              currentSpan.getBoundingClientRect().left - movingElementRight
            ) +
          currentSpan.getBoundingClientRect().width
      ) {
        currentSpan.style.left = `${
          startMarker.current?.position -
          currentSpan.getBoundingClientRect().width / 2 +
          startMarker.current?.pin.getBoundingClientRect().width * 5
        }px`;
      }
      // ovaj je za levo
      else if (
        sliderRight <
        movingElement.getBoundingClientRect().right +
          2 *
            Math.abs(
              movingElement.getBoundingClientRect().left -
                currentSpan.getBoundingClientRect().right
            ) +
          currentSpan.getBoundingClientRect().width
      ) {
        currentSpan.style.left = `${
          startMarker.current.position -
          currentSpan.getBoundingClientRect().width / 2 -
          startMarker.current.pin.getBoundingClientRect().width * 5
        }px`;
      } else {
        currentSpan.style.left = `${
          startMarker.current.position -
          currentSpan.getBoundingClientRect().width / 2 +
          startMarker.current.pin.getBoundingClientRect().width * 5
        }px`;
      }
    } else {
      //ovo je za end marker
      currentSpan = document.querySelector(".span-end");
      if (currentNotification.endTime !== "" && cond)
        currentSpan.innerHTML = currentNotification.endTime;
      else currentSpan.innerHTML = currentTime;
      const sliderLine = document.querySelector(".slider-line");
      const sliderLeft = sliderLine.getBoundingClientRect().left;
      const movingElementLeft = movingElement.getBoundingClientRect().left;

      if (
        sliderLeft <
        movingElementLeft -
          2 *
            Math.abs(
              currentSpan.getBoundingClientRect().right - movingElementLeft
            ) -
          currentSpan.getBoundingClientRect().width
      ) {
        currentSpan.style.left = `${
          endMarker.current.position -
          currentSpan.getBoundingClientRect().width / 2 -
          endMarker.current.pin.getBoundingClientRect().width * 5
        }px`;
      } else if (
        sliderLeft >
        movingElementLeft -
          2 *
            Math.abs(
              movingElement.getBoundingClientRect().right -
                currentSpan.getBoundingClientRect().left
            ) -
          currentSpan.getBoundingClientRect().width
      ) {
        currentSpan.style.left = `${
          endMarker.current.position -
          currentSpan.getBoundingClientRect().width / 2 +
          endMarker.current.pin.getBoundingClientRect().width * 5
        }px`;
      } else {
        currentSpan.style.left = `${
          endMarker.current.position -
          currentSpan.getBoundingClientRect().width / 2 -
          endMarker.current.pin.getBoundingClientRect().width * 5
        }px`;
      }
    }
  };

  const updateCurrentFill = () => {
    const fill = document.querySelector(".slider-line-fill");
    if (fill !== null) {
      let width = Math.abs(
        endMarker.current.position - startMarker.current.position
      );
      if (startMarker.current.position > endMarker.current.position) {
        fill.style.left = `${endMarker.current.position}px`;
        fill.style.right = `${startMarker.current.position}px`;
      } else {
        fill.style.left = `${startMarker.current.position}px`;
        fill.style.right = `${endMarker.current.position}px`;
      }
      fill.style.width = `${width}px`;
    }
  };

  const handleMoving = (e) => {
    if (isFromAdmin.current) {
      isFromSliderRef.current = true;
      const sliderMarkers = document.querySelector(".slider-markers");
      const movingElement = e.currentTarget;
      const dot = document.querySelector(".red-dot");
      if (
        dot &&
        e.clientX <
          dot.getBoundingClientRect().left +
            dot.getBoundingClientRect().width / 2
      ) {
        movingElement.style.left = `${
          dot.getBoundingClientRect().left -
          startMoving.current +
          dot.getBoundingClientRect().width / 2
        }px`;
        movingElement.classList.add("animate");
        movingElement.removeEventListener("mouseup", handleStopMoving);
      } else if (
        e.clientX - startMoving.current <
        sliderMarkers.getBoundingClientRect().left - startMoving.current
      ) {
        movingElement.style.left = `${
          -movingElement.getBoundingClientRect().width / 2
        }px`;
      } else if (
        e.clientX - startMoving.current >
        sliderMarkers.getBoundingClientRect().right - startMoving.current
      ) {
        movingElement.style.left = `${
          sliderMarkers.getBoundingClientRect().right - startMoving.current
        }px`;
      } else {
        movingElement.classList.remove("animate");
        isValidated = validate(movingElement);
        if (isValidated) e.currentTarget.style.backgroundColor = "green";
        else e.currentTarget.style.backgroundColor = "red";
        movingElement.style.left = `${e.clientX - startMoving.current}px`;
        const rect = movingElement.getBoundingClientRect();
        if (movingElement.classList.contains("start")) {
          startMarker.current = {
            pin: movingElement,
            width: rect.width,
            position: rect.left + rect.width - startMoving.current,
          };
        } else {
          endMarker.current = {
            pin: movingElement,
            width: rect.width,
            position: rect.left + rect.width - startMoving.current,
          };
        }
        calculateTime(movingElement);
        updateTimeSpan(movingElement);
        updateCurrentFill();
      }
    }
  };

  const validate = (movingElement) => {
    let isGood = true;

    const slider = document
      .querySelector(".slider-line")
      .getBoundingClientRect();
    let timePosition;
    let timeWidth = termWidth.current / 60;

    if (movingElement.classList.contains("start")) {
      timePosition =
        movingElement.getBoundingClientRect().left +
        movingElement.getBoundingClientRect().width / 2;

      let hours = parseInt((timePosition - slider.left) / timeWidth / 60);
      let minutes = parseInt(((timePosition - slider.left) / timeWidth) % 60);

      const endSpan = document.querySelector(".span-end");
      const endTime = endSpan.innerHTML.split(":");

      if (
        startMarker.current !== undefined &&
        endMarker.current !== undefined &&
        parseInt(endTime[0]) === hours &&
        parseInt(endTime[1]) === minutes
      ) {
        isGood = false;
      }
      if (startMarker.current?.position < dotPosition) isGood = false;
    } else {
      timePosition =
        movingElement.getBoundingClientRect().left +
        movingElement.getBoundingClientRect().width / 2;

      let hours = parseInt((timePosition - slider.left) / timeWidth / 60);
      let minutes = parseInt(((timePosition - slider.left) / timeWidth) % 60);

      const startSpan = document.querySelector(".span-start");
      const startTime = startSpan.innerHTML.split(":");

      if (
        startMarker.current !== undefined &&
        endMarker.current !== undefined &&
        parseInt(startTime[0]) === hours &&
        parseInt(startTime[1]) === minutes
      ) {
        isGood = false;
      }

      if (endMarker.current?.position < dotPosition) isGood = false;
    }
    return isGood;
  };

  const createFill = () => {
    const fill = document.querySelector(".slider-line-fill");
    if (fill) fill.remove();
    const sliderContainer = document.querySelector(".slider-line");
    const sliderLine = document.createElement("div");

    sliderLine.classList.add("slider-line-fill");
    const width = Math.abs(
      endMarker.current?.position - startMarker.current.position
    );

    sliderLine.style.width = `${width}px`;
    // korigovanje u zavisnosti od pozicije markera
    if (endMarker.current.position > startMarker.current.position) {
      sliderLine.style.left = `${startMarker.current.position}px`;
      sliderLine.style.right = `${endMarker.current.position}px`;
    } else {
      sliderLine.style.left = `${endMarker.current.position}px`;
      sliderLine.style.right = `${startMarker.current.position}px`;
    }
    sliderContainer.appendChild(sliderLine);
    fillCreated.current = true;
  };

  const createShift = () => {
    const spanFirst = document.querySelector(".span-start");
    const spanSecond = document.querySelector(".span-end");

    shift = {
      isStartMoved: startMarker.current !== undefined,
      isEndMoved: endMarker.current !== undefined,
      startTime: spanFirst.innerHTML,
      endTime: spanSecond.innerHTML,
    };

    let newStartTime = spanFirst.innerHTML;
    let newEndTime = spanSecond.innerHTML;
    if (startMarker.current === undefined && endMarker.current !== undefined) {
      newStartTime = spanSecond.innerHTML;
      newEndTime = spanFirst.innerHTML;
      setCurrentNotification({
        ...currentNotification,
        startTime: "",
        endTime: newStartTime,
        isFromSlider: true,
      });
    } else {
      setCurrentNotification({
        ...currentNotification,
        startTime: startMarker.current !== undefined ? newStartTime : "",
        endTime: endMarker.current !== undefined ? newEndTime : "",
        isFromSlider: true,
      });
    }
  };

  const correctPositions = (movingElement, validation) => {
    const slider = document
      .querySelector(".slider-line")
      .getBoundingClientRect();

    let isGood = true;

    const spanStart = document.querySelector(".span-start");
    const endSpan = document.querySelector(".span-end");
    const startTime = spanStart.innerHTML.split(":");
    const endTime = endSpan.innerHTML.split(":");

    if (endMarker.current !== undefined && startMarker.current !== undefined) {
      if (startTime[0] === endTime[0] && startTime[1] === endTime[1]) {
        isGood = false;
        validation.isValidated = false;
      }
    }
    /*
    if (
      parseInt(endMarker.current?.position) ===
        parseInt(startMarker.current?.position) + 1 ||
      parseInt(endMarker.current?.position) + 1 ===
        parseInt(startMarker.current?.position) ||
      parseInt(endMarker.current?.position) ===
        parseInt(startMarker.current?.position)
    ) {
      isGood = false;
      validation.isValidated = false;
    }
    */
    let timeWidth = termWidth.current / 60;

    let timePosition =
      movingElement.getBoundingClientRect().left +
      movingElement.getBoundingClientRect().width / 2;

    let correctTime = Math.round((timePosition - slider.left) / timeWidth);

    movingElement.style.left = `${
      correctTime * timeWidth - movingElement.getBoundingClientRect().width / 2
    }px`;

    if (startMarker.current?.pin === movingElement)
      if (isGood) {
        startMarker.current = {
          pin: movingElement,
          width: startMarker.current.width,
          position: correctTime * timeWidth,
        };
        correctSpanPositions(movingElement);
      } else {
        const fill = document.querySelector(".slider-line-fill");
        if (fill) fill.remove();
        fillCreated.current = false;
        const dot = document.querySelector(".red-dot");

        if (dot !== null) {
          movingElement.style.left = `${
            dot.getBoundingClientRect().left -
            dot.getBoundingClientRect().width / 2 -
            slider.left
          }px`;
        } else {
          movingElement.style.left = `${
            0 * termWidth.current -
            movingElement.getBoundingClientRect().width / 2
          }px`;
        }
        movingElement.style.backgroundColor = "gray";
        startMarker.current = undefined;
        correctSpanPositionsNull(movingElement);
      }
    else {
      if (isGood) {
        endMarker.current = {
          pin: movingElement,
          width: endMarker.current?.width,
          position: correctTime * timeWidth,
        };
        correctSpanPositions(movingElement);
      } else {
        const fill = document.querySelector(".slider-line-fill");
        if (fill) fill.remove();
        fillCreated.current = false;

        movingElement.style.left = `${
          24 * termWidth.current -
          movingElement.getBoundingClientRect().width / 2
        }px`;

        movingElement.style.backgroundColor = "gray";
        endMarker.current = undefined;
        correctSpanPositionsNull(movingElement);
      }
    }
  };

  const correctSpanPositionsNull = (movingElement) => {
    let currentSpan;
    currentSpan = document.querySelector(".span-start");
    const sliderMarkers = document.querySelectorAll(".slider-markers");

    if (movingElement.classList.contains("start")) {
      const dot = document.querySelector(".red-dot");
      if (dot !== null) {
        const slider = document
          .querySelector(".slider-line")
          .getBoundingClientRect();

        let timePosition =
          movingElement.getBoundingClientRect().left +
          movingElement.getBoundingClientRect().width / 2;

        let correctTime = Math.round(
          (timePosition - slider.left) / termWidth.current
        );

        let correctMinutes;
        let currentHours = new Date().getHours();
        let currentMinutes = new Date().getMinutes();
        if (currentMinutes > 30) {
          correctMinutes = "00";
          currentHours += 1;
        } else {
          correctMinutes = 30;
        }

        let span = document.createElement("span");
        span.innerHTML = `${currentHours}:${correctMinutes}`;

        const sliderLine = document.querySelector(".slider-line");
        const sliderRight = sliderLine.getBoundingClientRect().right;
        const markerRect = document.querySelector(".slider-marker.start");

        let arrowWidth =
          (sliderLine.getBoundingClientRect().width * 10) / 100 -
          markerRect.getBoundingClientRect().width / 2;

        if (
          sliderRight <
          markerRect.getBoundingClientRect().right +
            2 * Math.abs(arrowWidth) +
            currentSpan.getBoundingClientRect().width
        ) {
          span.style.left = `${
            markerRect.getBoundingClientRect().right -
            startMoving.current -
            currentSpan.getBoundingClientRect().width / 2 -
            markerRect.getBoundingClientRect().width * 5
          }px`;
        } else {
          span.style.left = `${
            markerRect.getBoundingClientRect().right -
            startMoving.current -
            currentSpan.getBoundingClientRect().width / 2 +
            markerRect.getBoundingClientRect().width * 5
          }px`;
        }
        currentSpan = document.querySelector(".span-start");
        if (currentSpan) currentSpan.remove();
        span.classList.add("span-start");
        sliderMarkers[0].appendChild(span);
      } else {
        currentSpan = document.querySelector(".span-start");
        if (currentSpan) currentSpan.remove();
        let span = document.createElement("span");
        span.innerHTML = "00:00";
        span.classList.add("span-start");
        sliderMarkers[0].appendChild(span);
      }
    } else {
      currentSpan = document.querySelector(".span-end");

      if (currentSpan) currentSpan.remove();
      let span = document.createElement("span");
      span.innerHTML = "24:00";
      span.classList.add("span-end");
      sliderMarkers[1].appendChild(span);
    }
  };

  const correctSpanPositions = (movingElement) => {
    let currentSpan, currentSpanEnd;
    currentSpan = document.querySelector(".span-start");
    currentSpanEnd = document.querySelector(".span-end");

    const sliderLine = document.querySelector(".slider-line");
    const sliderRight = sliderLine.getBoundingClientRect().right;
    const sliderLeft = sliderLine.getBoundingClientRect().left;
    const movingElementRight = movingElement.getBoundingClientRect().right;
    const movingElementLeft = movingElement.getBoundingClientRect().left;

    // ovaj uslov je za desno
    if (movingElement.classList.contains("start")) {
      if (
        sliderRight >
        movingElementRight +
          2 *
            Math.abs(
              movingElementRight - currentSpan.getBoundingClientRect().left
            ) +
          currentSpan.getBoundingClientRect().width
      ) {
        currentSpan = document.querySelector(".span-start");
        currentSpan.style.left = `${
          startMarker.current?.position -
          currentSpan.getBoundingClientRect().width / 2 +
          startMarker.current?.pin.getBoundingClientRect().width * 5
        }px`;
      } else if (
        sliderRight <
        movingElement.getBoundingClientRect().right +
          2 *
            Math.abs(
              movingElement.getBoundingClientRect().left -
                currentSpan.getBoundingClientRect().right
            ) +
          currentSpan.getBoundingClientRect().width
      ) {
        currentSpan = document.querySelector(".span-start");
        currentSpan.style.left = `${
          startMarker.current.position -
          currentSpan.getBoundingClientRect().width / 2 -
          startMarker.current.pin.getBoundingClientRect().width * 5
        }px`;
      }
    } else {
      if (
        sliderLeft >
        movingElementLeft -
          2 *
            Math.abs(
              currentSpanEnd.getBoundingClientRect().right - movingElementLeft
            ) -
          currentSpanEnd.getBoundingClientRect().width
      ) {
        currentSpanEnd = document.querySelector(".span-end");
        currentSpanEnd.style.left = `${
          endMarker.current.position -
          currentSpanEnd.getBoundingClientRect().width / 2 +
          endMarker.current.pin.getBoundingClientRect().width * 5
        }px`;
      } else if (
        sliderLeft <
        movingElementLeft -
          2 *
            Math.abs(
              movingElement.getBoundingClientRect().right -
                currentSpanEnd.getBoundingClientRect().left
            ) -
          currentSpanEnd.getBoundingClientRect().width
      ) {
        currentSpanEnd = document.querySelector(".span-end");
        currentSpanEnd.style.left = `${
          endMarker.current.position -
          currentSpanEnd.getBoundingClientRect().width / 2 -
          endMarker.current.pin.getBoundingClientRect().width * 5
        }px`;
      }
    }

    /*
    if (
      sliderRight >
      movingElementRight +
        2 *
          Math.abs(
            movingElementRight - currentSpan.getBoundingClientRect().left
          ) +
        currentSpan.getBoundingClientRect().width
    ) {
      if (movingElement.classList.contains("start")) {
        currentSpan = document.querySelector(".span-start");
        currentSpan.style.left = `${
          startMarker.current.position -
          currentSpan.getBoundingClientRect().width / 2 +
          startMarker.current.pin.getBoundingClientRect().width * 5
        }px`;
      } else {
        currentSpan = document.querySelector(".span-end");
        currentSpan.style.left = `${
          endMarker.current.position -
          currentSpan.getBoundingClientRect().width / 2 +
          endMarker.current.pin.getBoundingClientRect().width * 5
        }px`;
      }
    } else if (
      sliderRight <
      movingElement.getBoundingClientRect().right +
        2 *
          Math.abs(
            movingElement.getBoundingClientRect().left -
              currentSpan.getBoundingClientRect().right
          ) +
        currentSpan.getBoundingClientRect().width
    ) {
      if (movingElement.classList.contains("start")) {
        currentSpan = document.querySelector(".span-start");

        currentSpan.style.left = `${
          startMarker.current.position -
          currentSpan.getBoundingClientRect().width / 2 -
          startMarker.current.pin.getBoundingClientRect().width * 5
        }px`;
      } else {
        currentSpan = document.querySelector(".span-end");
        currentSpan.style.left = `${
          endMarker.current.position -
          currentSpan.getBoundingClientRect().width / 2 -
          endMarker.current.pin.getBoundingClientRect().width * 5
        }px`;
      }
    }
    */
  };

  const handleDecreaseMinutes = (e) => {
    const validation = {
      isValidated: true,
    };
    const timeSpan = e.currentTarget.parentNode.querySelector("span");
    const movingElement = e.currentTarget.parentNode.firstChild;
    const arrows = document.querySelectorAll(".arrow");
    const fill = document.querySelector(".slider-line-fill");
    const dot = document.querySelector(".red-dot");
    const slider = document
      .querySelector(".slider-line")
      .getBoundingClientRect();
    const time = timeSpan.innerHTML.split(":");
    let minutes = parseInt(time[1]);
    let hours = parseInt(time[0]);

    if (minutes === 0) {
      minutes = 60;
      hours -= 1;
    }
    let correctMinutes;
    let currentHours = new Date().getHours();
    let currentMinutes = new Date().getMinutes();
    if (currentMinutes > 30) {
      correctMinutes = 0;
      currentHours += 1;
    } else {
      correctMinutes = 30;
    }

    console.log(correctMinutes);
    console.log(minutes);
    console.log(correctMinutes >= (minutes === 60 ? 0 : minutes));
    console.log(
      correctMinutes === 0 ? currentHours > hours : currentHours >= hours
    );

    if (
      hours < 0 ||
      ((correctMinutes === 0 ? currentHours > hours : currentHours >= hours) &&
        correctMinutes >= (minutes === 60 ? 0 : minutes) &&
        dot !== null)
    ) {
      if (movingElement.classList.contains("start")) {
        if (fill) fill.remove();
        fillCreated.current = false;
        if (arrows.length !== 0) arrows.forEach((arrow) => arrow.remove());

        if (dot !== null) {
          movingElement.style.left = `${
            dot.getBoundingClientRect().left -
            dot.getBoundingClientRect().width / 2 -
            slider.left
          }px`;
        } else {
          movingElement.style.left = `${
            0 * termWidth.current -
            movingElement.getBoundingClientRect().width / 2
          }px`;
        }
        movingElement.style.backgroundColor = "gray";
        startMarker.current = undefined;
        correctSpanPositionsNull(movingElement);
      } else {
        if (arrows.length !== 0) arrows.forEach((arrow) => arrow.remove());
        if (fill) fill.remove();
        fillCreated.current = false;

        movingElement.style.left = `${
          24 * termWidth.current -
          movingElement.getBoundingClientRect().width / 2
        }px`;

        movingElement.style.backgroundColor = "gray";
        endMarker.current = undefined;
        correctSpanPositionsNull(movingElement);
      }
      return;
    }

    minutes = minutes - 1;

    let timeWidth = termWidth.current / 60;

    movingElement.style.left = `${
      movingElement.getBoundingClientRect().left - timeWidth - slider.left
    }px`;

    timeSpan.style.left = `${
      timeSpan.getBoundingClientRect().left - timeWidth - slider.left
    }px`;

    arrows[0].style.left = `${
      arrows[0].getBoundingClientRect().left - timeWidth - slider.left
    }px`;

    arrows[1].style.left = `${
      arrows[1].getBoundingClientRect().left - timeWidth - slider.left
    }px`;
    arrows[0].remove();
    arrows[1].remove();

    if (minutes < 10) minutes = `0${minutes}`;
    timeSpan.innerHTML = `${hours}:${minutes}`;

    correctPositions(movingElement, validation);

    createSetting(movingElement, validation);
    if (
      fillCreated.current &&
      startMarker.current !== undefined &&
      endMarker.current !== undefined
    ) {
      createFill();
    }
  };

  const handleIncreaseMinutes = (e) => {
    const validation = {
      isValidated: true,
    };

    const timeSpan = e.currentTarget.parentNode.querySelector("span");
    const movingElement = e.currentTarget.parentNode.firstChild;
    const arrows = document.querySelectorAll(".arrow");
    const fill = document.querySelector(".slider-line-fill");

    const slider = document
      .querySelector(".slider-line")
      .getBoundingClientRect();
    const time = timeSpan.innerHTML.split(":");

    let minutes = parseInt(time[1]);
    let hours = parseInt(time[0]);

    if (hours === 24) {
      if (movingElement.classList.contains("start")) {
        if (fill) fill.remove();
        fillCreated.current = false;
        if (arrows.length !== 0) arrows.forEach((arrow) => arrow.remove());
        const dot = document.querySelector(".red-dot");
        if (dot !== null) {
          movingElement.style.left = `${
            dot.getBoundingClientRect().left -
            dot.getBoundingClientRect().width / 2 -
            slider.left
          }px`;
        } else {
          movingElement.style.left = `${
            0 * termWidth.current -
            movingElement.getBoundingClientRect().width / 2
          }px`;
        }
        movingElement.style.backgroundColor = "gray";
        startMarker.current = undefined;
        correctSpanPositionsNull(movingElement);
      } else {
        if (arrows.length !== 0) arrows.forEach((arrow) => arrow.remove());
        if (fill) fill.remove();
        fillCreated.current = false;

        movingElement.style.left = `${
          24 * termWidth.current -
          movingElement.getBoundingClientRect().width / 2
        }px`;

        movingElement.style.backgroundColor = "gray";
        endMarker.current = undefined;
        correctSpanPositionsNull(movingElement);
      }
      return;
    }
    minutes = minutes + 1;

    if (minutes >= 60) {
      minutes = 0;
      hours += 1;
    }

    let timeWidth = termWidth.current / 60;

    movingElement.style.left = `${
      movingElement.getBoundingClientRect().left + timeWidth - slider.left
    }px`;

    timeSpan.style.left = `${
      timeSpan.getBoundingClientRect().left + timeWidth - slider.left
    }px`;

    arrows[0].remove();
    arrows[1].remove();

    if (minutes < 10) minutes = `0${minutes}`;
    timeSpan.innerHTML = `${hours}:${minutes}`;

    correctPositions(movingElement, validation);

    createSetting(movingElement, validation);

    if (
      fillCreated.current &&
      startMarker.current !== undefined &&
      endMarker.current !== undefined
    ) {
      createFill();
    }
  };

  const createSetting = (movingElement, validation) => {
    let currentSpan;
    let startingMarker = document.querySelector(".slider-marker.start");
    let startSpan = document.querySelector(".span-start");
    let endSpan = document.querySelector(".span-end");
    if (movingElement === startingMarker) {
      if (validation.isValidated) currentSpan = startSpan;
      else currentSpan = endSpan;
    } else {
      if (validation.isValidated) currentSpan = endSpan;
      else currentSpan = startSpan;
    }

    let arrow = document.createElement("img");
    const adminPanel = window.innerHeight * 0.023;

    arrow.src = playLeft;

    arrow.classList.add("arrow");
    arrow.style.left = `${
      currentSpan.getBoundingClientRect().left -
      startMoving.current -
      adminPanel
    }px`;
    arrow.addEventListener("click", handleDecreaseMinutes);
    currentSpan.parentNode.appendChild(arrow);

    arrow = document.createElement("img");
    arrow.src = playRight;
    arrow.classList.add("arrow");
    arrow.style.left = `${
      currentSpan.getBoundingClientRect().right -
      startMoving.current +
      currentSpan.getBoundingClientRect().width / 4
    }px`;
    arrow.addEventListener("click", handleIncreaseMinutes);
    currentSpan.parentNode.appendChild(arrow);
  };

  const handleStopMoving = (e) => {
    isFromAdmin.current = false;
    e.currentTarget.removeEventListener("mousemove", handleMoving);
    const validation = {
      isValidated: true,
    };
    calculateTimeWithMinutes(e.currentTarget);
    updateTimeSpan(e.currentTarget);
    correctPositions(e.currentTarget, validation);
    if (fillCreated.current) updateCurrentFill();
    if (
      !fillCreated.current &&
      startMarker.current !== undefined &&
      endMarker.current !== undefined
    ) {
      createFill();
    }
    if (startMarker.current !== undefined || endMarker.current !== undefined)
      createShift();
    // kreiranje finog podesavanja

    createSetting(e.currentTarget, validation);
  };

  const calculateWidthTerm = () => {
    const slider = document
      .querySelector(".slider-line")
      .getBoundingClientRect();
    termWidth.current = slider.width / 24;
  };

  const calculateTime = (movingElement) => {
    const slider = document
      .querySelector(".slider-line")
      .getBoundingClientRect();
    let timePosition;
    timePosition =
      movingElement.getBoundingClientRect().left +
      movingElement.getBoundingClientRect().width / 2;
    const correctTime = parseInt(
      (timePosition - slider.left) / termWidth.current
    );
    if (correctTime < 10) currentTime = `0${correctTime}:00`;
    else currentTime = `${correctTime}:00`;
  };

  const calculateTimeWithMinutes = (movingElement) => {
    const slider = document
      .querySelector(".slider-line")
      .getBoundingClientRect();
    let timePosition;
    let timeWidth = termWidth.current / 60;
    timePosition =
      movingElement.getBoundingClientRect().left +
      movingElement.getBoundingClientRect().width / 2;

    let hours = parseInt((timePosition - slider.left) / timeWidth / 60);
    let minutes = parseInt(((timePosition - slider.left) / timeWidth) % 60);

    let correctHours, correctMinutes;

    if (hours < 10) correctHours = `0${hours}`;
    else correctHours = `${hours}`;
    if (minutes < 10) correctMinutes = `0${minutes}`;
    else correctMinutes = `${minutes}`;
    currentTime = correctHours + ":" + correctMinutes;
  };

  const correctMarkerPositions = (isFillCreated, isLoaded) => {
    console.log(isFillCreated);
    let endDot = true;
    const sliderLeft = document
      .querySelector(".slider-line")
      .getBoundingClientRect().left;
    console.log(isFillCreated || currentNotification.startTime !== "");
    if (
      (isFillCreated || currentNotification.startTime !== "") &&
      (isEditing ? currentNotification.isFromSlider : isFromSliderRef.current)
    ) {
      console.log("Uso u prvi if");
      let markerRect = document.querySelector(".slider-marker.start");
      if (currentNotification.startTime !== "") {
        if (startMarker.current === undefined) {
          startMarker.current = {
            pin: markerRect,
            width: markerRect.getBoundingClientRect().width,
            position:
              termWidth.current *
              parseInt(currentNotification.startTime.split(":")[0]),
          };
        }
        markerRect.style.left = `${
          startMarker.current.position - startMarker.current.width / 2
        }px`;
        markerRect.style.backgroundColor = "green";
      }

      const dot = document.querySelector(".red-dot");
      markerRect = document.querySelector(".slider-marker.start");

      if (
        currentNotification.startTime !== "" &&
        startMarker.current !== undefined
      )
        updateTimeSpan(startMarker.current.pin, true);
      if (currentNotification.endTime !== "" && endMarker.current !== undefined)
        updateTimeSpan(endMarker.current.pin, true);

      if (
        dot &&
        markerRect.getBoundingClientRect().left <
          dot.getBoundingClientRect().left
      ) {
        const fill = document.querySelector(".slider-line-fill");
        if (fill) fill.remove();
        fillCreated.current = false;

        markerRect.style.left = `${
          dot.getBoundingClientRect().left -
          dot.getBoundingClientRect().width / 2 -
          sliderLeft
        }px`;

        markerRect.style.backgroundColor = "gray";
        startMarker.current = undefined;
        endDot = false;
        setCurrentNotification({
          ...currentNotification,
          startTime: "",
        });

        correctSpanPositionsNull(markerRect);
      }

      if (
        currentNotification.startTime === "" &&
        currentNotification.endTime !== ""
      ) {
        let redDot = document.querySelector(".red-dot");
        markerRect = document.querySelector(".slider-marker.start");
        if (redDot !== null) {
          markerRect.style.left = `${
            redDot.getBoundingClientRect().left -
            sliderLeft -
            redDot?.getBoundingClientRect().width / 2
          }px`;
        } else {
          markerRect.style.left = `${
            -markerRect.getBoundingClientRect().width / 2
          }px`;
          let currentSpan = document.querySelector(".span-start");
          currentSpan.innerHTML = "00:00";

          currentSpan.style.left = `${
            markerRect.getBoundingClientRect().right -
            startMoving.current +
            currentSpan.getBoundingClientRect().width
          }px`;
        }
      }

      markerRect = document.querySelector(".slider-marker.end");
      if (currentNotification.endTime !== "") {
        if (endMarker.current === undefined) {
          endMarker.current = {
            pin: markerRect,
            width: markerRect.getBoundingClientRect().width,
            position:
              parseInt(currentNotification.endTime.split(":")[0]) *
              termWidth.current,
          };
        }
        markerRect.style.left = `${
          endMarker.current.position - endMarker.current.width / 2
        }px`;
        markerRect.style.backgroundColor = "green";
      }

      if (
        dot &&
        markerRect.getBoundingClientRect().left <
          dot.getBoundingClientRect().left
      ) {
        const fill = document.querySelector(".slider-line-fill");
        if (fill) fill.remove();
        fillCreated.current = false;

        markerRect.style.left = `${
          24 * termWidth.current - markerRect.getBoundingClientRect().width / 2
        }px`;

        markerRect.style.backgroundColor = "gray";
        endMarker.current = undefined;
        endDot = false;
        setCurrentNotification({
          ...currentNotification,
          endTime: "",
        });
        correctSpanPositionsNull(markerRect);
      }
    } else {
      const dot = document.querySelector(".red-dot");
      let markerRect = document.querySelector(".slider-marker.start");
      console.log(dot);
      if (dot !== null) {
        markerRect.style.left = `${
          dot.getBoundingClientRect().left -
          sliderLeft -
          dot?.getBoundingClientRect().width / 2
        }px`;
      } else {
        markerRect.style.left = `${
          -markerRect.getBoundingClientRect().width / 2
        }px`;
      }
      if (dot === null) {
        markerRect = document.querySelector(".slider-marker.end");
        markerRect.style.right = `${
          -markerRect.getBoundingClientRect().width / 2
        }px`;
      }

      let currentSpan = document.querySelector(".span-start");
      markerRect = document.querySelector(".slider-marker.start");
      if (dot !== null) {
        let correctMinutes;
        let currentHours = new Date().getHours();
        let currentMinutes = new Date().getMinutes();
        if (currentMinutes > 30) {
          correctMinutes = "00";
          currentHours += 1;
        } else {
          correctMinutes = 30;
        }
        currentSpan.innerHTML = `${currentHours}:${correctMinutes}`;

        const sliderLine = document.querySelector(".slider-line");
        const sliderRight = sliderLine.getBoundingClientRect().right;

        let arrowWidth =
          (sliderLine.getBoundingClientRect().width * 10) / 100 -
          markerRect.getBoundingClientRect().width / 2;

        if (
          sliderRight <
          markerRect.getBoundingClientRect().right +
            2 * Math.abs(arrowWidth) +
            currentSpan.getBoundingClientRect().width
        ) {
          currentSpan.style.left = `${
            markerRect.getBoundingClientRect().right -
            startMoving.current -
            currentSpan.getBoundingClientRect().width / 2 -
            markerRect.getBoundingClientRect().width * 5
          }px`;
        } else if (
          sliderRight >
          markerRect.getBoundingClientRect().right +
            2 * Math.abs(arrowWidth) +
            currentSpan.getBoundingClientRect().width
        ) {
          currentSpan.style.left = `${
            markerRect.getBoundingClientRect().right -
            startMoving.current -
            currentSpan.getBoundingClientRect().width / 2 +
            markerRect.getBoundingClientRect().width * 5
          }px`;
        }
      } else {
        currentSpan.innerHTML = "00:00";
        currentSpan.style.left = `${
          markerRect.getBoundingClientRect().right -
          startMoving.current +
          currentSpan.getBoundingClientRect().width
        }px`;
      }
    }
    if (
      !fillCreated.current &&
      isFillCreated &&
      !isLoaded &&
      isFillCreated &&
      isEditing
        ? currentNotification.isFromSlider
        : isFromSliderRef.current
    ) {
      if (
        currentNotification.startTime !== "" &&
        currentNotification.endTime !== "" &&
        endDot
      )
        createFill();
    }
  };

  const fillLines = () => {
    const sliderLine = document.querySelector(".slider-line-podeok");
    for (let i = 0; i < 24; i++) {
      let div = document.createElement("div");
      div.classList.add("slider-podeok");
      div.style.width = `${termWidth.current}px`;
      sliderLine.appendChild(div);
    }
  };

  const createTimeSpans = () => {
    const sliderMarkers = document.querySelectorAll(".slider-markers");
    let span = document.createElement("span");
    span.innerHTML = "00:00";
    span.classList.add("span-start");
    sliderMarkers[0].appendChild(span);

    span = document.createElement("span");
    span.innerHTML = "24:00";
    span.classList.add("span-end");
    sliderMarkers[1].appendChild(span);
  };

  const correctMarkerPositionChangeDot = () => {
    const dot = document.querySelector(".red-dot");
    const sliderMarkers = document.querySelector(".slider-marker.start");
    if (sliderMarkers === undefined) return;
    const sliderLeft = document
      .querySelector(".slider-line")
      .getBoundingClientRect().left;

    sliderMarkers.style.left = `${
      dot.getBoundingClientRect().left -
      dot.getBoundingClientRect().width / 2 -
      sliderLeft
    }px`;
    correctSpanPositionsNull(sliderMarkers);
  };

  const calculateDotPosition = () => {
    const sliderLine = document.querySelector(".slider-line");
    let correctDotLeft, currentHours, currentMinutes, corectMinutes;
    currentHours = new Date().getHours();
    currentMinutes = new Date().getMinutes();
    if (currentMinutes > 30) {
      corectMinutes = 0;
      currentHours += 1;
    } else {
      corectMinutes = 30;
    }
    correctDotLeft =
      currentHours * termWidth.current +
      (termWidth.current / 60) * corectMinutes;
    const dotDiv = document.createElement("div");
    dotDiv.classList.add("red-dot");
    sliderLine.appendChild(dotDiv);
    dotPosition = correctDotLeft - dotDiv.getBoundingClientRect().width / 2;
    dotDiv.style.left = `${dotPosition}px`;
    if (currentMinutes === 0 && currentMinutes === 30)
      correctMarkerPositionChangeDot();
  };

  useEffect(() => {
    const sliderMarkers = document.querySelector(".slider-markers");
    const marker = document.querySelector(".slider-marker");
    startMoving.current =
      sliderMarkers.getBoundingClientRect().x +
      marker.getBoundingClientRect().width / 2;
    calculateWidthTerm();
    fillLines();
    createTimeSpans();
    correctMarkerPositions(
      currentNotification.startTime !== "" &&
        currentNotification.endTime !== "",
      false
    );
    fillCreated.current = false;
  }, []);

  useEffect(() => {
    let dot = document.querySelector(".red-dot");
    if (dot !== null) dot.remove();
    if (
      compareAsc(
        new Date(new Date().setHours(0, 0, 0, 0)),
        new Date(new Date(selectedDate).setHours(0, 0, 0, 0))
      ) === 0
    ) {
      calculateDotPosition();
    }

    correctMarkerPositions(
      currentNotification.startTime !== "" &&
        currentNotification.endTime !== "",
      true
    );

    const arrows = document.querySelectorAll(".arrow");
    arrows.forEach((arrow) => arrow.remove());
    let interval = setInterval(() => {
      dot = document.querySelector(".red-dot");
      if (dot !== null) dot.remove();
      if (
        compareAsc(
          new Date(new Date().setHours(0, 0, 0, 0)),
          new Date(new Date(selectedDate).setHours(0, 0, 0, 0))
        ) === 0
      )
        calculateDotPosition();
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [selectedDate]);

  return (
    <div className="slider">
      <div className="slider-markers">
        <div
          className="slider-marker start"
          onMouseDown={(e) => handleStartMoving(e)}
          onMouseUp={(e) => handleStopMoving(e)}
        />
      </div>
      <div className="slider-line">
        <div className="slider-line-podeok" />
      </div>
      <div className="slider-markers">
        <div
          className="slider-marker end"
          onMouseDown={(e) => handleStartMoving(e)}
          onMouseUp={(e) => handleStopMoving(e)}
        />
      </div>
    </div>
  );
};

export default Slider;
